import React, { useState } from 'react';
import { Box, Button, Container, Typography, Paper, CircularProgress } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export const Login: React.FC = () => {
  const { signInWithGoogle, error, usuario } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    try {
      setLoading(true);
      await signInWithGoogle();
      navigate('/');
    } catch (err) {
      // Error will be handled by AuthContext and displayed in UI
    } finally {
      setLoading(false);
    }
  };

  // Si el usuario ya está autenticado, redirigir a la página principal
  React.useEffect(() => {
    if (usuario) {
      navigate('/');
    }
  }, [usuario, navigate]);

  return (
    <Box className="login-page">
      <Container component="main" maxWidth="xs" className="login-container">
        <Paper
          elevation={6}
          className="login-paper"
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            borderRadius: 2,
          }}
        >
          <img 
            src="/Logo.png" 
            alt="Mat ByB Logo" 
            className="login-logo"
          />
          
          <Typography 
            component="h1" 
            variant="h5" 
            gutterBottom 
            sx={{ 
              fontWeight: 600,
              color: 'primary.main',
              textAlign: 'center',
              mb: 1
            }}
          >
            Mat ByB
          </Typography>
          
          <Typography 
            component="h2" 
            variant="h6" 
            sx={{ 
              fontWeight: 500,
              mb: 1
            }}
          >
            Sistema de Gestión de Materiales
          </Typography>
          
          <Typography 
            variant="body1" 
            color="text.secondary" 
            align="center" 
            sx={{ mb: 4 }}
          >
            Accede a tu cuenta para gestionar los materiales de tus obras
          </Typography>

          <Button
            fullWidth
            variant="contained"
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <GoogleIcon />}
            onClick={handleGoogleSignIn}
            disabled={loading}
            sx={{ 
              mt: 2,
              py: 1.5,
              borderRadius: 2,
              fontSize: '1rem',
              textTransform: 'none',
              boxShadow: 2,
              '&:hover': {
                boxShadow: 4,
                transform: 'translateY(-2px)',
              },
              transition: 'all 0.3s ease'
            }}
          >
            {loading ? 'Iniciando sesión...' : 'Continuar con Google'}
          </Button>

          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              ¿Quieres usar el Widget en tu pantalla de inicio?
            </Typography>
            <Button
              variant="text"
              color="primary"
              href="/mat_byb_widget.apk"
              download="mat_byb_widget.apk"
              sx={{ textTransform: 'none', mt: 1 }}
            >
              Descargar Aplicación del Widget (APK)
            </Button>
          </Box>

          {error && (
            <Typography 
              color="error" 
              sx={{ 
                mt: 3,
                p: 2,
                bgcolor: 'error.light',
                borderRadius: 1,
                width: '100%',
                textAlign: 'center'
              }}
            >
              Error al iniciar sesión: {error}
            </Typography>
          )}
        </Paper>
      </Container>
    </Box>
  );
};